"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.SocialLink = exports.SocialIconWrapper = exports.SocialWrapper = exports.SectionHeader = exports.Sales = exports.LoveWrapper = exports.LogoRow = exports.LinkList = exports.LinkWrapper = exports.LegalLinkWrapper = exports.LegalLinkSection = exports.LegalLink = exports.Grouping = exports.Divider = exports.CopyRightTitle = exports.CopyRightRow = exports.AdditionalInfoWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sections = _interopRequireDefault(require("../contentful-views/sections"));

var _gridContainer = require("../grid-container");

var _markdown = _interopRequireDefault(require("../markdown"));

var _link = _interopRequireDefault(require("../link"));

var _linkBase = _interopRequireDefault(require("../link/link-base"));

var _typography = require("../typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LinkList = (0, _styledComponents["default"])('nav').withConfig({
  displayName: "footerstyles__LinkList",
  componentId: "sc-1fckozc-0"
})(["display:inline-flex;flex-direction:column;justify-content:flex-start;padding-bottom:16px;> ", "{margin:4px 0;--font-weight:500;}"], _linkBase["default"]);
exports.LinkList = LinkList;
var SectionHeader = (0, _styledComponents["default"])(_typography.Paragraph).withConfig({
  displayName: "footerstyles__SectionHeader",
  componentId: "sc-1fckozc-1"
})(["color:", ";margin-bottom:8px;align-self:flex-start;"], function (props) {
  return props.theme.colors.slate.lightest;
});
exports.SectionHeader = SectionHeader;
var Grouping = (0, _styledComponents["default"])('div').withConfig({
  displayName: "footerstyles__Grouping",
  componentId: "sc-1fckozc-2"
})(["width:50%;@media ", "{min-width:15%;max-width:20%;padding-right:16px;}"], function (props) {
  return props.theme.queries.desktopAndUp;
});
exports.Grouping = Grouping;
var Sales = (0, _styledComponents["default"])('div').withConfig({
  displayName: "footerstyles__Sales",
  componentId: "sc-1fckozc-3"
})(["display:none;@media ", "{display:inherit;}"], function (props) {
  return props.theme.queries.desktopAndUp;
});
exports.Sales = Sales;
var SocialLink = (0, _styledComponents["default"])(_link["default"]).withConfig({
  displayName: "footerstyles__SocialLink",
  componentId: "sc-1fckozc-4"
})(["width:44px;&:not(:first-child){margin-left:12px;}> .button-icon-wrapper{margin-left:0;> div{justify-content:center;}svg{height:100%;max-height:44px;width:100%;max-width:44px;}}"]);
exports.SocialLink = SocialLink;
var SocialIconWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "footerstyles__SocialIconWrapper",
  componentId: "sc-1fckozc-5"
})(["display:flex;justify-content:space-between;width:100%;height:44px;@media ", "{justify-content:flex-end;}"], function (props) {
  return props.theme.queries.desktopAndUp;
});
exports.SocialIconWrapper = SocialIconWrapper;
var SocialWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "footerstyles__SocialWrapper",
  componentId: "sc-1fckozc-6"
})(["order:-1;width:100%;padding:0 0 32px 0;display:flex;flex-direction:column;align-items:flex-end;> ", "{display:none;}@media ", "{margin-left:auto;order:unset;width:unset;flex:1;padding:0;> ", "{display:inherit;}}"], SectionHeader, function (props) {
  return props.theme.queries.desktopAndUp;
}, SectionHeader);
exports.SocialWrapper = SocialWrapper;
var LinkWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "footerstyles__LinkWrapper",
  componentId: "sc-1fckozc-7"
})(["display:flex;flex-direction:row;flex-wrap:wrap;padding-bottom:48px;"]);
exports.LinkWrapper = LinkWrapper;
var LoveWrapper = (0, _styledComponents["default"])(_sections["default"]).withConfig({
  displayName: "footerstyles__LoveWrapper",
  componentId: "sc-1fckozc-8"
})(["display:flex;justify-content:end;align-items:center;", " && img{margin:0 4px;width:16px;}"], (0, _typography.getTypographyVariant)('body'));
exports.LoveWrapper = LoveWrapper;
var CopyRightTitle = (0, _styledComponents["default"])(_markdown["default"]).withConfig({
  displayName: "footerstyles__CopyRightTitle",
  componentId: "sc-1fckozc-9"
})(["&& p{font-size:0.75rem;}"]);
exports.CopyRightTitle = CopyRightTitle;
var LegalLink = (0, _styledComponents["default"])(_link["default"]).withConfig({
  displayName: "footerstyles__LegalLink",
  componentId: "sc-1fckozc-10"
})(["font-size:0.75rem;"]);
exports.LegalLink = LegalLink;
var Divider = (0, _styledComponents["default"])('div').withConfig({
  displayName: "footerstyles__Divider",
  componentId: "sc-1fckozc-11"
})(["border-left:2px solid ", ";padding:0;margin:2px 6px;"], function (props) {
  return props.theme.colors.slate.lightest;
});
exports.Divider = Divider;
var LegalLinkWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "footerstyles__LegalLinkWrapper",
  componentId: "sc-1fckozc-12"
})(["display:flex;"]);
exports.LegalLinkWrapper = LegalLinkWrapper;
var LegalLinkSection = (0, _styledComponents["default"])('nav').withConfig({
  displayName: "footerstyles__LegalLinkSection",
  componentId: "sc-1fckozc-13"
})(["display:flex;flex-wrap:wrap;justify-content:center;>:nth-child(even){> ", "{display:none;}}@media ", "{>:nth-child(even){> ", "{display:inherit;}}}"], Divider, function (props) {
  return props.theme.queries.tabletAndUp;
}, Divider);
exports.LegalLinkSection = LegalLinkSection;
var AdditionalInfoRow = (0, _styledComponents["default"])('div').withConfig({
  displayName: "footerstyles__AdditionalInfoRow",
  componentId: "sc-1fckozc-14"
})(["display:flex;flex-direction:column;justify-content:space-between;padding-top:16px;@media ", "{flex-direction:row;}"], function (props) {
  return props.theme.queries.desktopAndUp;
});
var LogoRow = (0, _styledComponents["default"])(AdditionalInfoRow).withConfig({
  displayName: "footerstyles__LogoRow",
  componentId: "sc-1fckozc-15"
})(["align-items:center;&& span{svg{width:124px;height:auto;}}"]);
exports.LogoRow = LogoRow;
var CopyRightRow = (0, _styledComponents["default"])(AdditionalInfoRow).withConfig({
  displayName: "footerstyles__CopyRightRow",
  componentId: "sc-1fckozc-16"
})(["align-items:center;@media ", "{align-items:baseline;}"], function (props) {
  return props.theme.queries.desktopAndUp;
});
exports.CopyRightRow = CopyRightRow;
var AdditionalInfoWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "footerstyles__AdditionalInfoWrapper",
  componentId: "sc-1fckozc-17"
})(["display:flex;flex-direction:column;border-top:2px solid ", ";padding-top:16px;"], function (props) {
  return props.theme.colors.slate.lightest;
});
exports.AdditionalInfoWrapper = AdditionalInfoWrapper;
var Wrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "footerstyles__Wrapper",
  componentId: "sc-1fckozc-18"
})(["grid-column:main-start / main-end;"]);
exports.Wrapper = Wrapper;